<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>

      <BackButton
          :label="$t('general.button.back')"
          :to="{ name: 'unemployedNewAndActiveList' }"
          marginBottom="5"/>

      <h6 class="element-header">Kundendetails</h6>

      <div class="element-box">
        <UnemployedDetails :unemployed="unemployed"/>
        <CoachingMenu :unemployed="unemployed" :coachingCounts="coachingCounts"/>

        <div class="row mb-2 mt-4" style="padding: 0 10px">
          <div class="col-lg-6">
            <h6>Einzelcoaching-Maßnahmenn</h6>
          </div>

          <div class="col-lg-6">
            <p style="margin-bottom: 10px; text-align: center">
              Neue Maßnahme anlegen:
            </p>
            <div class="d-flex flex-row-reverse">
              <button type="button" class="btn btn-primary mb-2" style="padding: 5px 7px;"
                      @click="handleModalInquiryForm">
                Standort (Praxis unbekannt und muss aktiv angefragt werden
              </button>
              <button type="button" class="btn btn-primary mb-2 mr-2" style="padding: 5px 7px;"
                      @click="handleModalForm">
                Standort (Praxis) ist bekannt
              </button>
            </div>
          </div>
        </div>


        <div class="table-responsive overflow-auto mt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Status</th>
              <th>Maßnahmenart</th>
              <th>Office</th>
              <th>Start</th>
              <th>Ende</th>
              <th>Stand</th>
              <th>Stand %</th>
              <th>UN fehlt</th>
              <th>Coach 1</th>
              <th>UE Coach 1</th>
              <th>Coach 2</th>
              <th>UE Coach 2</th>
              <th>Coach 3</th>
              <th>UE Coach 3</th>
              <th>Coach 4</th>
              <th>UE Coach 4</th>
              <th>Geva Testung</th>
              <th>Noch abzurechnende Stunden</th>
              <th>Letzter Termin</th>
              <th>Bericht</th>
              <th>Modul genehmigen</th>
              <th>Bearbeiten</th>
              <th>LÖSCHEN</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(coaching, index) in privateCoachingList" :key="index">
              <!-- Coaching Status -->
              <td style="min-width: 100px;"> {{ coaching.statusTranslated }}</td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.nameOfCoaching.operationTypeTranslated }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                    <span v-if="
                      coaching.type === 'regular' ||
                      coaching.type === '' ||
                      coaching.type === null ||
                      coaching.type === undefined">
                      {{ coaching.unemployed?.location?.name }}
                    </span>
                  <span v-else>
                      <span v-for="(office, i) in coaching.offices" :key="i">
                        {{ office.office.name }}
                        <template v-if="i < coaching.offices.length - 1">, &nbsp;</template>
                      </span>
                    </span>
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.startDate }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.endDate }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.unitsDone }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.unitsDonePercent }}%
                </strong>
              </td>
              <td style="text-align: center">
                <strong class="js-lists-values-employee-name">
                  {{ coaching.notSignedUnits }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.coach1?.firstName }} {{ coaching.coach1?.lastName }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.unitsDoneCoach1 }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.coach2?.firstName }} {{ coaching.coach2?.lastName }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.unitsDoneCoach2 }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.coach3?.firstName }} {{ coaching.coach3?.lastName }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.unitsDoneCoach3 }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.coach4?.firstName }} {{ coaching.coach4?.lastName }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.unitsDoneCoach4 }}
                </strong>
              </td>
              <td style="text-align: center">
                <strong class="js-lists-values-employee-name">
                  {{ coaching.gevaStatusTranslated }}
                </strong>
              </td>

              <td style="text-align: center">
                <strong class="js-lists-values-employee-name">
                  {{ coaching.countNotBilledMeetings }}
                </strong>
              </td>
              <td>
                <strong class="js-lists-values-employee-name">
                  {{ coaching.lastUnit }}
                </strong>
              </td>

              <td>
                <div v-if="coaching.status !== 'in_allocation' && coaching.status !== 'approval_pending'">
                  <router-link
                      v-if="coaching.nameOfCoaching.operationType === 'go_work_mobile'"
                      :to="{ name: 'privateCoachingGoWorkMobileFirstInterviewForm', params: { id: coaching.id } }"
                      class="btn btn-primary">
                    Bericht
                  </router-link>
                  <router-link
                      v-else-if="coaching.nameOfCoaching.operationType === 'modular_integration_coaching'"
                      :to="{ name: 'privateCoachingMicFirstInterviewV2Form', params: { id: coaching.id } }"
                      class="btn btn-primary">
                    Bericht
                  </router-link>
                  <router-link
                      v-else
                      :to="{ name: 'privateCoachingFirstInterviewForm', params: { id: coaching.id } }"
                      class="btn btn-primary">
                    Bericht
                  </router-link>
                </div>
              </td>
              <td>
                <div v-if="coaching.status !== 'in_allocation' && coaching.status !== 'approval_pending'">
                  <button
                      v-if="['modular_integration_coaching', 'go_work_mobile'].includes(coaching.nameOfCoaching.operationType)"
                      type="button" class="btn btn-outline-primary"
                      @click="handleModalApproveModuleForm(coaching.id)" style="padding: 5px 7px;">
                    Genehmigen
                  </button>
                </div>
              </td>
              <td>
                <button v-if="['new', 'active', 'finished'].includes(coaching.status)" type="button"
                        class="btn  btn-outline-primary" @click="handleEditModalForm(coaching.id)"
                        style="padding: 5px 7px;">
                  Bearbeiten
                </button>
                <button v-else type="button" class="btn  btn-outline-primary"
                        @click="handleEditInquiryModalForm(coaching.id)" style="padding: 5px 7px;">
                  Bearbeiten
                </button>
              </td>

              <!-- Delete -->
              <td class="text-center">
                <button class="btn btn-danger ml-2" @click="handleDeleteModal(coaching?.id)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <Modal
          v-model="showModalForm"
          title="Einzelcoaching - Standort (Praxis) ist bekannt"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-xl"
          :hide-footer="true"
          classFooter="justify-content-center">

        <Form
            v-if="companySettings.companyKey === 'BSG'"
            :privateCoachingId="privateCoachingId"
            :unemployedId="unemployed?.id"
            :locationId="unemployed?.location?.id"
            :locationName="unemployed?.location?.name"
            v-model:submitForm="submitForm"/>
        <BBQForm
            v-else
            :privateCoachingId="privateCoachingId"
            :unemployedId="unemployed?.id"
            :locationId="unemployed?.location?.id"
            :locationName="unemployed?.location?.name"
            v-model:submitForm="submitForm"/>
      </Modal>

      <Modal
          v-model="showModalInquiryForm"
          title="Einzelcoaching - Standort (Praxis unbekannt und muss aktiv angefragt werden)"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-xl"
          :hide-footer="true"
          classFooter="justify-content-center">
        <InquiryForm
            :privateCoachingId="privateCoachingId"
            :unemployedId="unemployed?.id"
            :locationId="unemployed?.location?.id"
            :locationName="unemployed?.location?.name"
            v-model:submitForm="submitForm"/>
      </Modal>

      <Modal
          v-model="showModalApproveModule"
          title="Modul genehmigen" :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-lg"
          :hide-footer="true"
          classFooter="justify-content-center">
        <ApproveModuleForm
            :privateCoachingId="privateCoachingId"
            :unemployedId="unemployed?.id"
            v-model:submitForm="submitForm"/>
      </Modal>

      <ModalDelete
          v-model="showDeleteModal" :header="t('general.delete_item_header')"
          :onDelete="deletePrivateCoaching">
      </ModalDelete>
    </div>
  </PageTemplate>
</template>

<script setup>
import unemployedService from '@/api/Unemployed';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import CoachingMenu from '@/views/App/Unemployed/Coaching/CoachingMenu.vue';
import ApproveModuleForm from '@/views/App/Unemployed/Coaching/PrivateCoaching/ApproveModuleForm.vue';
import Form from '@/views/App/Unemployed/Coaching/PrivateCoaching/Form.vue';
import InquiryForm from '@/views/App/Unemployed/Coaching/PrivateCoaching/InquiryForm.vue';
import UnemployedDetails from '@/views/App/Unemployed/UnemployedDetails.vue';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";
import BBQForm from "@/views/App/Unemployed/Coaching/PrivateCoaching/BBQForm.vue";
import BackButton from "@/components/button/BackButton.vue";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

const {t} = useI18n();
const route = useRoute();
const unemployedId = route.params.id;
const unemployed = ref(null);
const coachingCounts = ref(null);
const privateCoachingId = ref(null);
const privateCoachingList = ref([]);
const showModalForm = ref(false);
const showModalInquiryForm = ref(false);
const showModalApproveModule = ref(false);
const showDeleteModal = ref(false);
const submitForm = ref(false);
const isLoaded = ref(false);

async function getUnemployedOverviewData() {
  try {
    const {data} = await unemployedService.getUnemployedOverview(unemployedId);
    unemployed.value = data.data.unemployed;
    coachingCounts.value = data.data.coachingCounts;

  } catch (error) {
    await ErrorToast(error);
  }
}

async function getPrivateCoachingList() {
  try {
    const {data} = await unemployedPrivateCoachingService.getPrivateCoachingList(unemployedId);
    privateCoachingList.value = data.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

watch(submitForm, () => {
  privateCoachingId.value = null; // Important
  showModalForm.value = false;
  showDeleteModal.value = false;
  showModalInquiryForm.value = false;
  showModalApproveModule.value = false;
  getUnemployedOverviewData();
  getPrivateCoachingList();
});

// Regular
function handleModalForm() {
  CloseToast();
  privateCoachingId.value = null; // Important
  showModalForm.value = true;
  showDeleteModal.value = false;
  showModalInquiryForm.value = false;
  showModalApproveModule.value = false;
}

function handleEditModalForm(id) {
  CloseToast();
  privateCoachingId.value = id;
  showModalForm.value = true;
}

// Inquiry
function handleModalInquiryForm() {
  CloseToast();
  privateCoachingId.value = null; // Important
  showModalInquiryForm.value = true;
  showDeleteModal.value = false;
  showModalForm.value = false;
  showModalApproveModule.value = false;
}

function handleEditInquiryModalForm(id) {
  CloseToast();
  privateCoachingId.value = id;
  showModalInquiryForm.value = true;
  showDeleteModal.value = false;
  showModalForm.value = false;
  showModalApproveModule.value = false;
}

// Approve module
function handleModalApproveModuleForm(id) {
  CloseToast();
  privateCoachingId.value = id;
  showModalApproveModule.value = true;
  showModalInquiryForm.value = false;
  showDeleteModal.value = false;
  showModalForm.value = false;
}

// Delete
function handleDeleteModal(id) {
  CloseToast();
  showDeleteModal.value = true;
  showModalForm.value = false;
  showModalInquiryForm.value = false;
  privateCoachingId.value = id;
}

async function deletePrivateCoaching() {
  try {
    await unemployedPrivateCoachingService.deletePrivateCoaching(privateCoachingId.value);

    privateCoachingId.value = null;
    showDeleteModal.value = false;

    await getPrivateCoachingList();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}


onMounted(async () => {
  CloseToast();

  await Promise.all([
    getUnemployedOverviewData(),
    getPrivateCoachingList(),
  ]);

  isLoaded.value = true;
});

</script>

<style scoped></style>